<template>
    <v-layout row>
        <v-dialog v-model="dialog" persistent max-width="1000px">
            <v-btn slot="activator" color="secondary" class="text--primary">Add new product</v-btn>
            <v-card>
                <form v-on:submit.prevent="create">
                    <v-card-title>
                        <span class="headline">Add new product</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required'"
                                            v-model="data.code"
                                            :error-messages="errors.collect('data.code')"
                                            label="Code"
                                            data-vv-name="data.code"
                                            browser-autocomplete="off"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required'"
                                            v-model="data.product_description"
                                            :error-messages="errors.collect('data.product_description')"
                                            label="Product description"
                                            data-vv-name="data.product_description"
                                            browser-autocomplete="off"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="''"
                                            v-model="data.sample_ref"
                                            :error-messages="errors.collect('data.sample_ref')"
                                            label="Sample reference"
                                            data-vv-name="data.sample_ref"
                                            browser-autocomplete="off"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required|decimal'"
                                            v-model="data.units"
                                            :error-messages="errors.collect('data.units')"
                                            label="Units"
                                            data-vv-name="data.units"
                                            browser-autocomplete="off"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required|decimal'"
                                            v-model="data.units_kg"
                                            :error-messages="errors.collect('data.units_kg')"
                                            label="Units Kg"
                                            data-vv-name="data.units_kg"
                                            v-on:change="calcularPrecio()"
                                            browser-autocomplete="off"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required|decimal'"
                                            v-model="data.price_kg"
                                            :error-messages="errors.collect('data.price_kg')"
                                            :label="'Price ' + label"
                                            data-vv-name="data.price_kg"
                                            v-on:change="calcularPrecio()"
                                            browser-autocomplete="off"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'decimal'"
                                            v-model="data.iva"
                                            :error-messages="errors.collect('data.iva')"
                                            label="Vat"
                                            data-vv-name="data.iva"
                                            v-on:change="calcularPrecio()"
                                            browser-autocomplete="off"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required|decimal'"
                                            v-model="data.price"
                                            :error-messages="errors.collect('data.price')"
                                            label="Price"
                                            data-vv-name="data.price"
                                            browser-autocomplete="off"

                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-autocomplete
                                            v-model="data.tipo_unidad_id"
                                            :items="types"
                                            label="Type unit"
                                            item-text="name"
                                            item-value="id"
                                            v-on:change="editLabel"
                                            browser-autocomplete="off"
                                    >
                                    </v-autocomplete>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click.native="cancel()">Cancel</v-btn>
                        <v-btn color="blue darken-1" flat type="submit">Save</v-btn>
                    </v-card-actions>
                </form>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import { DICCIONARIO } from '../../../../../diccionario';

    export default {
        props: ['id'],
        data: () => ({
            dialog: false,
            data : {
                product_description : '',
                name: '',
                sample_ref: '',
                units: '0',
                units_kg: '0',
                price_kg: '0',
                price: '0',
                id: '',
                iva: 0,
                tipo_unidad_id: null,
            },
            types: null,
            label: 'Kg',
        }),
        created () {
            this.data.id = this.id;
            this.getTypeUnits();
        },
        mounted () {
            this.$validator.localize('en', DICCIONARIO)
        },
        watch: {
            dialog: function () {
                this.data.iva = 0;
            }
        },
        methods: {
            create () {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        if (this.data.iva == '') {
                            this.data.iva = 0;
                        }
                        this.$store.dispatch('createOrderLine', this.data).then((res) => {
                            this.$emit('created');
                            this.data = {
                                product_description : '',
                                name: '',
                                sample_ref: '',
                                units: '0',
                                units_kg: '0',
                                price_kg: '0',
                                price: '0',
                                iva: 10,
                                tipo_unidad_id: null,
                                id: this.id
                            };
                            this.dialog = false
                        }).catch((error) => {

                        });
                    }
                });
            },
            cancel () {
                this.dialog = false;
                this.data = {
                    product_description : '',
                    name: '',
                    sample_ref: '',
                    units: '0',
                    units_kg: '0',
                    price_kg: '0',
                    price: '0',
                    id: this.id
                };
            },
            calcularPrecio () {
                this.data.price = this.data.units_kg * this.data.price_kg;
            },
            getTypeUnits () {
                this.$store.dispatch('selectTypeUnits').then((res) => {
                    this.types = res.data;
                }).catch((error) => {

                });
            },
            editLabel () {
                if (this.data.tipo_unidad_id == 2) {
                    this.label = 'Units';
                } else {
                    this.label = 'Kgs';
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/admin/orders/views/components/CreateProduct.vue